import { functions } from '@/firebase'

const createSessionToken = async (isPro: boolean = false) => {
	const createToken = functions.httpsCallable('auth_create_session_token')

	const result = await createToken({
		isPro
	})

	return result.data.token
}

export {
	createSessionToken
}
